import InformationModule from './InformationModule';

export * from './InformationModule';
export default InformationModule;
